import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { AccountsApi, type FileResponse, type GenerateAccountConfirmationLetterRequest, type WithSignal } from '@shared/api';

const generateAccountConfirmationLetterEffect = createEffect(({ signal, ...request }: WithSignal<GenerateAccountConfirmationLetterRequest>) =>
  AccountsApi.generateAccountConfirmationLetter(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<FileResponse | null>(null)
  .on(generateAccountConfirmationLetterEffect.done, (_, data) => data.result || null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(generateAccountConfirmationLetterEffect.pending, (_, data) => data)
  .on(generateAccountConfirmationLetterEffect.fail, () => false)
  .on(generateAccountConfirmationLetterEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(generateAccountConfirmationLetterEffect, () => null)
  // .on(getAccountsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(generateAccountConfirmationLetterEffect.fail, (_, data) =>
    ApiUtils.abortApiErrorFailCaseTrigger(data.error, 'Something went wrong while generating Account Confirmation Letter. Please try again.'),
  )
  .on(generateAccountConfirmationLetterEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $generateAccountConfirmationLetterStore = {
  events: {
    generateAccountConfirmationLetter: generateAccountConfirmationLetterEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
